export * from './actions';
export * from './effects';
export * from './service';

export { featureKey as townKey, initialState as townInitialState, State as TownState } from './reducer';

export {
  getData as townGetData,
  getError as townGetError,
  getLoading as townGetLoading,
  mapData as townMapData,
} from './selectors';
